export interface LoginMFAReq {
  Username: string;
  OktaStatetoken: string;
  QuoteId: string;
}

export interface LoginMFARes {
  Username?: string;
  OktaId: string;
  OktaStateToken: string;
  OktaUserStatus: string;
  DeviceToken: string;
  PolicyNum: string;
  FactorId: string;
  Factors: [];
  Phone: string;
  RememberDeviceByDefault: boolean;
  Status: string;
  Warnings: [];
  Errors: [];
}

export interface VerifyMFAReq {
  Username: string;
  OktaId: string;
  OktaStateToken: string;
  FactorId: string;
  Passcode: string;
  RememberDevice: boolean;
}
export interface VerifyMFARes {
  OktaUserStatus: string;
  Phone: string;
  Status: string;
  Warnings: [];
  Errors: [];
}

export interface EnrollMFAReq {
  Username: string;
  OktaId: string;
  OktaStateToken: string;
  Phone: string;
}

export interface EnrollMFARes {
  OktaUserStatus: string;
  FactorId: string;
  Phone: string;
  Status: string;
  Warnings: [];
  Errors: [];
}

export interface ActivateMFAReq {
  Username: string;
  OktaId: string;
  OktaStateToken: string;
  FactorId: string;
  Passcode: string;
}
export interface ActivateMFARes {
  OktaUserStatus: string;
  Phone: string;
  Status: string;
  Warnings: [];
  Errors: [];
}

export interface SuretyRes {
  SuretyUrl: string;
  Status: string;
  Warnings: [];
  Errors: [];
}
